import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import DateField from '../../components/DateField';
import { fetchSupervisorClosedTirages } from '../../api/supervisor';
import { todayISO } from '../../utils/date';
import './SupervisorCloseSalesPage.css';

const WEEKDAY_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

// Variante superviseur (2026-09-17) de pages/central/CloseSalesPage.jsx —
// LECTURE SEULE : le superviseur voit les loteries fermees de sa company
// (fermeture manuelle recurrente/ponctuelle OU simplement l'heure de
// fermeture deja passee aujourd'hui), mais ne peut pas fermer/rouvrir
// (TirageClosure est 100% company-wide, decision explicite de ne pas y
// toucher cote superviseur — reste une action company-only).
const SupervisorCloseSalesPage = () => {
  const [date, setDate] = useState(todayISO());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchSupervisorClosedTirages({ date })
      .then((d) => { if (!cancelled) setRows(d.rows); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les loteries fermées — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [date]);

  return (
    <SupervisorLayout>
      <p className="svcs-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svcs-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/central" className="svcs-link">Central</Link>
        {' >> '}
        <span className="svcs-current">Fermer Vente</span>
      </p>

      <div className="svcs-card">
        <div className="svcs-card-header">
          <span className="svcs-card-title">Loteries fermées</span>
        </div>
        <div className="svcs-card-body">
          <p className="svcs-help">
            Consultation seule — la fermeture/réouverture d'une loterie reste une action
            de la company (affecte toutes ses banques, pas seulement les tiennes).
          </p>

          <div className="svcs-row">
            <label className="svcs-label">Date</label>
            <DateField className="svcs-input svcs-input-date" value={date} onChange={setDate} />
          </div>

          {error && <p className="svcs-error">{error}</p>}
          {loading && <p className="svcs-loading">Chargement...</p>}

          {!loading && !error && rows.length === 0 && (
            <p className="svcs-empty">Aucune loterie fermée pour cette date.</p>
          )}

          {!loading && !error && rows.length > 0 && (
            <table className="svcs-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Lottery</th>
                  <th>End time</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.code}>
                    <td className="svcs-td-code">{row.code}</td>
                    <td className="svcs-td-name">{row.name}</td>
                    <td className="svcs-td-time">{row.end_time || '—'}</td>
                    <td>
                      {row.hour_closed && <span className="svcs-chip svcs-chip-hour">Heure passée</span>}
                      {row.weekdays.map((w) => (
                        <span key={`w-${w}`} className="svcs-chip">{WEEKDAY_LABELS[w] || `J${w}`}</span>
                      ))}
                      {row.dates.map((d) => (
                        <span key={`d-${d}`} className="svcs-chip">{d}</span>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorCloseSalesPage;
